export default "<!-- <app-qrcode-scanner *ngIf=\"web\"></app-qrcode-scanner> -->\n";